import type { LocaleCode, LocaleIsoCode } from "@/types";
import {
  DEFAULT_ISO_LOCALE,
  DEFAULT_LOCALE,
  LOCALE_TO_ISO,
  LOCALES,
} from "@/helpers/localization";

export default function extractLocaleAndUrl(path: string[] | undefined): {
  url: string;
  locale: LocaleCode;
  isoLocale: LocaleIsoCode;
} {
  if (!path) {
    return {
      url: "/",
      locale: DEFAULT_LOCALE,
      isoLocale: DEFAULT_ISO_LOCALE,
    };
  }

  // Leading slash
  const normalizedPath = path[0] === "" ? path.slice(1) : path;

  const pathIncludesLocale = LOCALES.includes(normalizedPath[0] as LocaleCode);
  const locale = (pathIncludesLocale ? normalizedPath[0] : "en-us") as LocaleCode;
  const url = pathIncludesLocale
    ? normalizedPath.slice(1).join("/")
    : normalizedPath.join("/");

  return {
    locale: locale,
    isoLocale: LOCALE_TO_ISO[locale],
    url: url.length === 0 ? "/" : url.startsWith("/") ? url : `/${url}`,
  };
}
